(function () {
  'use strict';

  angular.module('app').component('clientProfileSeasonList', clientProfileSeasonList());

  function clientProfileSeasonList() {
    return {
      bindings: {
        clientProfile: '=',
        clientProfileSeasons: '=',
        priceLists: '=',
        onClientProfileSeasonsUpdated: '&',
      },
      controller: ClientProfileSeasonListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/client-profiles/components/client-profile-seasons/client-profile-season-list/client-profile-season-list.component.html',
    };
  }

  ClientProfileSeasonListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    '$timeout',
    'ClientProfileSeasonService',

    // Angular downgraded service
    'seasonService',
    'seasonModalService',
  ];

  function ClientProfileSeasonListCtrl(
    config,
    UtilService,
    AbilityService,
    $timeout,
    ClientProfileSeasonService,

    // Angular downgraded service
    seasonService,
    seasonModalService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_clientprofile_accountadmin'),
      canShow: AbilityService.can('show_clientprofile_accountadmin'),
      canUpdate: AbilityService.can('update_clientprofile_accountadmin'),
      canDestroy: AbilityService.can('destroy_clientprofile_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      vm.clientProfileSeasons = seasonService.setCurrentSeasons(vm.clientProfileSeasons);

      // Load current client profile season
      if (vm.clientProfileSeasons.length > 0) {
        showClientProfileSeason(vm.clientProfileSeasons[0], 'view');
      }

      // Initializers
      getSeasons();
    };

    // Methods
    vm.groupSeasonsByYears = groupSeasonsByYears;
    vm.openSeasonsModal = openSeasonsModal;

    vm.showAvailableSeasonsPopover = showAvailableSeasonsPopover;
    vm.hideAvailableSeasonsPopover = hideAvailableSeasonsPopover;

    vm.addClientProfileSeason = addClientProfileSeason;
    vm.removeClientProfileSeason = removeClientProfileSeason;
    vm.showClientProfileSeason = showClientProfileSeason;

    vm.onClientProfileSeasonSaved = onClientProfileSeasonSaved;
    vm.onClientProfileSeasonDeleted = onClientProfileSeasonDeleted;
    vm.onClientProfileSeasonCanceled = onClientProfileSeasonCanceled;

    // ----- SEASONS ----- //

    // Get active seasons
    function getSeasons(showAvailableSeasonsMode = false) {
      // current, where to is equal or less than today, check utc
      seasonService.getSeasons({ get: 'current' }).subscribe((reponse) => {
        vm.seasons = reponse.filter((season) => season.name); // In case of empty translation

        getAvailableSeasons(showAvailableSeasonsMode);
      });
    }

    function groupSeasonsByYears(season) {
      return seasonService.groupSeasonsByYears(season);
    }

    // vm.filterByCurrentSeasons = filterByCurrentSeasons;
    // Display only current seasons and avoid duplicate seasons, except the current season
    /*function filterByCurrentSeasons(currentSeasonId) {
            return function(seasonItem) {
                return seasonService.filterByCurrentSeasons(seasonItem, currentSeasonId, [], vm.today);
            };
        }*/

    function openSeasonsModal() {
      vm.showAvailableSeasonsMode = false;

      var successCallback = function () {
        getSeasons(true);
      };

      seasonModalService.openSeasonsModal(successCallback);
    }

    function getAvailableSeasons(showAvailableSeasonsMode = false) {
      var currentSeasons = [];
      vm.clientProfileSeasons.forEach(function (clientProfileSeason) {
        currentSeasons.push({ id: clientProfileSeason.season_id });
      });

      vm.availableSeasons = vm.UtilService.getAvailableItemsInTwoArrays(
        vm.seasons,
        currentSeasons,
        'id'
      );

      vm.season = null;

      // To re-open popover if there are seasons after closing de seasons modal
      if (vm.availableSeasons.length > 0 && showAvailableSeasonsMode) {
        vm.showAvailableSeasonsMode = true;
      }
    }

    function showAvailableSeasonsPopover() {
      vm.showAvailableSeasonsMode = true;
    }

    function hideAvailableSeasonsPopover() {
      vm.showAvailableSeasonsMode = false;
      vm.season = null;
    }

    function addClientProfileSeason(clientProfileSeason) {
      if (!vm.permissions.canCreate) {
        return;
      }

      vm.mode = 'create';

      vm.clientProfileSeason = null;
      $timeout(function () {
        // Hack
        if (clientProfileSeason) {
          vm.clientProfileSeason = clientProfileSeason;
          return;
        }

        vm.clientProfileSeason = {
          season_id: vm.season.id,
          season: {
            name: vm.season.name,
            from: vm.season.from,
            to: vm.season.to,
          },
          new: true,
        };

        hideAvailableSeasonsPopover();

        // Append season to clientProfileSeasons
        vm.clientProfileSeasons.push(vm.clientProfileSeason);
        getAvailableSeasons();
      }, 50);
    }

    function removeClientProfileSeason(index) {
      vm.clientProfileSeasons.splice(index, 1);
      getAvailableSeasons();

      vm.showAvailableSeasonsMode = false;
      vm.clientProfileSeason = null;
      vm.mode = null;
    }

    function showClientProfileSeason(clientProfileSeason, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.mode = mode || 'view';

      if (!clientProfileSeason.id) {
        addClientProfileSeason(clientProfileSeason);
        return;
      }

      hideAvailableSeasonsPopover();

      vm.clientProfileSeason = null;
      vm.loadingClientProfileSeason = true;
      ClientProfileSeasonService.getClientProfileSeason(
        clientProfileSeason,
        vm.clientProfile.id
      ).then(function (data) {
        vm.clientProfileSeason = data;

        vm.loadingClientProfileSeason = false;
      });
    }

    function onClientProfileSeasonSaved(response) {
      delete vm.clientProfileSeason.new;
      //vm.mode = null;

      vm.onClientProfileSeasonsUpdated();
    }

    function onClientProfileSeasonDeleted(idSeasonDeleted) {
      var indexItemDeleted = vm.UtilService.findArrayIndex(
        vm.clientProfileSeasons,
        'id',
        idSeasonDeleted
      );

      removeClientProfileSeason(indexItemDeleted);
    }

    function onClientProfileSeasonCanceled(mode) {
      if (mode !== 'edit') {
        vm.clientProfileSeason = null;
        vm.mode = null;

        if (mode === 'create') {
          var indexItemToCreate = vm.UtilService.findArrayIndex(
            vm.clientProfileSeasons,
            'new',
            true
          );

          removeClientProfileSeason(indexItemToCreate);
        }

        return;
      }

      showClientProfileSeason(vm.clientProfileSeason, 'view');
    }
  }
})();
